export default "__VITE_ASSET__sJzHDRSv__ 800w, __VITE_ASSET__7ZFt$c_M__ 600w, __VITE_ASSET__sC0k$gsS__ 400w";